module.exports = __webpack_public_path__ + "static/media/006-Boston Pizza Huntsville.1c1042b1.jpeg";